import type { BaseModelData } from '../../../data/model';
import { IEvent } from '../../../shared/EventAggregator';

export class RequestQuoteInitiatedEvent implements IEvent {
  constructor(
    public readonly product: BaseModelData | Pick<BaseModelData, 'id' | 'name' | 'brandName'>,
    public readonly configurationCode: string,
    public readonly currencyCode: string,
    public readonly quantity: number,
  ) {}
}
